import React from 'react';
import './Services.css';

const Services: React.FC = () => {
  const services = [
    {
      title: 'Sistemas ERP',
      description: 'Planificación de recursos empresariales que integra y automatiza todos los procesos de tu negocio.',
      icon: <svg width="32" height="32" viewBox="0 0 24 24" fill="none" stroke="#78f9fb" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
        <rect x="2" y="3" width="20" height="14" rx="2" ry="2"/>
        <line x1="8" y1="21" x2="16" y2="21"/>
        <line x1="12" y1="17" x2="12" y2="21"/>
        <rect x="6" y="7" width="12" height="6" rx="1" ry="1"/>
      </svg>
    },
    {
      title: 'Sistemas CRM',
      description: 'Gestión de relaciones con clientes para optimizar ventas, marketing y servicio al cliente.',
      icon: <svg width="32" height="32" viewBox="0 0 24 24" fill="none" stroke="#78f9fb" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
        <path d="M17 21v-2a4 4 0 0 0-4-4H5a4 4 0 0 0-4 4v2"/>
        <circle cx="9" cy="7" r="4"/>
        <path d="M23 21v-2a4 4 0 0 0-3-3.87"/>
        <path d="M16 3.13a4 4 0 0 1 0 7.75"/>
      </svg>
    },
    {
      title: 'Automatización de Procesos',
      description: 'Eliminamos tareas repetitivas y manuales para liberar tiempo y recursos de tu equipo.',
      icon: <svg width="32" height="32" viewBox="0 0 24 24" fill="none" stroke="#78f9fb" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
        <circle cx="12" cy="12" r="3"/>
        <path d="M12 1v6m0 6v6"/>
        <path d="M4.22 4.22l4.24 4.24m5.08 5.08l4.24 4.24"/>
        <path d="M1 12h6m6 0h6"/>
        <path d="M4.22 19.78l4.24-4.24m5.08-5.08l4.24-4.24"/>
      </svg>
    },
    {
      title: 'Dashboards y Reportes',
      description: 'Visualización de datos en tiempo real para tomar mejores decisiones con claridad.',
      icon: <svg width="32" height="32" viewBox="0 0 24 24" fill="none" stroke="#78f9fb" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
        <line x1="18" y1="20" x2="18" y2="10"/>
        <line x1="12" y1="20" x2="12" y2="4"/>
        <line x1="6" y1="20" x2="6" y2="14"/>
      </svg>
    },
    {
      title: 'Integración de Sistemas',
      description: 'Conectamos todas tus herramientas y sistemas para que trabajen como uno solo.',
      icon: <svg width="32" height="32" viewBox="0 0 24 24" fill="none" stroke="#78f9fb" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
        <path d="M10 13a5 5 0 0 0 7.54.54l3-3a5 5 0 0 0-7.07-7.07l-1.72 1.71"/>
        <path d="M14 11a5 5 0 0 0-7.54-.54l-3 3a5 5 0 0 0 7.07 7.07l1.71-1.71"/>
      </svg>
    },
    {
      title: 'Consultoría Digital',
      description: 'Asesoramiento estratégico para la transformación digital de tu empresa.',
      icon: <svg width="32" height="32" viewBox="0 0 24 24" fill="none" stroke="#78f9fb" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
        <path d="M14.7 6.3a1 1 0 0 0 0 1.4l1.6 1.6a1 1 0 0 0 1.4 0l3.77-3.77a6 6 0 0 1-7.94 7.94l-6.91 6.91a2.12 2.12 0 0 1-3-3l6.91-6.91a6 6 0 0 1 7.94-7.94l-3.76 3.76z"/>
      </svg>
    },
    {
      title: 'Soluciones con IA',
      description: 'Implementación de inteligencia artificial para optimizar procesos y mejorar la toma de decisiones.',
      icon: <svg width="32" height="32" viewBox="0 0 24 24" fill="none" stroke="#78f9fb" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
        <path d="M12 2a3 3 0 0 0-3 3c0 .5.12 1 .34 1.42C6.28 7.52 4 10.36 4 14c0 1.66.68 3.26 1.88 4.42A7 7 0 1 0 12 2z"/>
        <circle cx="12" cy="10" r="3"/>
        <path d="M12 1v6m0 0 4-4m-4 4L8 3"/>
      </svg>
    },
    {
      title: 'Desarrollo Web',
      description: 'Aplicaciones web modernas y responsivas para tu negocio.',
      icon: <svg width="32" height="32" viewBox="0 0 24 24" fill="none" stroke="#78f9fb" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
        <polyline points="16 18 22 12 16 6"/>
        <polyline points="8 6 2 12 8 18"/>
      </svg>
    }
  ];

  return (
    <section id="soluciones" className="services">
      <div className="container">
        <h2 className="section-title">Nuestras Soluciones</h2>
        <p className="section-subtitle">
          Automatizamos, optimizamos y transformamos la gestión empresarial para que puedas enfocarte en lo que realmente importa
        </p>
        <div className="services-grid">
          {services.map((service, index) => (
            <div key={index} className="service-card">
              <div className="service-icon">{service.icon}</div>
              <h3>{service.title}</h3>
              <p>{service.description}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Services;